import React from 'react';
import { teacher_notes_view } from './teacher_notes_rules';

// Shared by the 1-on-1 and group/workshop session pages; format_time renders the notes timestamps.
const TeacherNotesSection = ({ details, format_time, empty_text }) => {
  const v = teacher_notes_view(details);
  return (
    <div className="teacher-notes-section" data-testid="teacher-notes">
      <h3>Teacher notes: </h3>
      {v.is_empty ? (
        <p>{empty_text || 'The teacher left no notes for this session.'}</p>
      ) : (
        <table>
          <tbody>
            <tr className="table-row-left-align">
              <td className="teacher-table-detail">Recap: </td>
              <td>{v.recap || '--'}</td>
            </tr>
            <tr className="table-row-left-align">
              <td className="teacher-table-detail">Notes: </td>
              <td>{v.notes || '--'}</td>
            </tr>
            <tr className="table-row-left-align">
              <td className="teacher-table-detail">Created At:</td>
              <td>{format_time(v.notes_created_at)}</td>
            </tr>
            <tr className="table-row-left-align">
              <td className="teacher-table-detail">Updated At:</td>
              <td>{format_time(v.notes_updated_at)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TeacherNotesSection;
